(function () {
  if (window.__YKFAQAccordionLoaded) return;
  window.__YKFAQAccordionLoaded = true;

  const ITEM_SELECTOR = '[data-faq-item]';
  const SECTION_SELECTOR = '[data-faq-section]';

  function getHashId() {
    if (!window.location.hash) return '';

    try {
      return decodeURIComponent(window.location.hash.slice(1));
    } catch (error) {
      return window.location.hash.slice(1);
    }
  }

  function setHash(id) {
    if (!id || getHashId() === id) return;

    const url = `${window.location.pathname}${window.location.search}#${encodeURIComponent(id)}`;
    window.history.replaceState(null, '', url);
  }

  function clearHash(id) {
    if (!id || getHashId() !== id) return;

    const url = `${window.location.pathname}${window.location.search}`;
    window.history.replaceState(null, '', url);
  }

  function syncQuestionState(item) {
    const question = item.querySelector(':scope > .faq-question');
    if (!question) return;

    question.classList.toggle('active', item.open);
    question.setAttribute('aria-expanded', String(item.open));
  }

  function closeOtherItems(currentItem) {
    document.querySelectorAll(`${SECTION_SELECTOR} ${ITEM_SELECTOR}[open]`).forEach((item) => {
      if (item !== currentItem) item.open = false;
    });
  }

  function initialiseItem(item) {
    if (item.dataset.faqInitialised === 'true') return;
    item.dataset.faqInitialised = 'true';

    syncQuestionState(item);

    item.addEventListener('toggle', function () {
      syncQuestionState(item);

      if (item.open) {
        closeOtherItems(item);
        setHash(item.id);
      } else {
        clearHash(item.id);
      }
    });
  }

  function scrollToItem(item) {
    // Two animation frames ensure the <details> element has expanded before scrolling.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        item.scrollIntoView({ block: 'start' });
      });
    });
  }

  function openItemFromHash(options = {}) {
    const id = getHashId();
    if (!id) return false;

    const item = document.getElementById(id);
    if (!item || !item.matches(ITEM_SELECTOR)) return false;

    closeOtherItems(item);
    item.open = true;
    syncQuestionState(item);

    if (options.scroll !== false) {
      scrollToItem(item);
    }

    return true;
  }

  function initialiseFAQs(root = document) {
    root.querySelectorAll(ITEM_SELECTOR).forEach(initialiseItem);
    openItemFromHash();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseFAQs(document);
    }, { once: true });
  } else {
    initialiseFAQs(document);
  }

  window.addEventListener('hashchange', function () {
    openItemFromHash();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initialiseFAQs(event.target);
  });
})();